import { FilterConfig } from './filter-config';
import {OptionsMap} from "@/types";

export type MultiSelectItem = { code: string; label: string };
export type MultiSelectValue = MultiSelectItem[];

export class MultiselectFilterConfig extends FilterConfig {
  get defaultValue(): MultiSelectValue {
    return [];
  }


  isEmpty(value: MultiSelectValue): boolean {
    return !Array.isArray(value) || value.length === 0;
  }

  toLabel(filterData: MultiSelectValue): string | null {
    if (!Array.isArray(filterData) || filterData.length === 0) return null;
    return filterData.map(item => item.label).join(', ');
  }

  toQuery(filterData: MultiSelectValue): string[] | null {
    if (!Array.isArray(filterData) || filterData.length === 0) return null;
    return filterData.map(item => (typeof item === 'object' ? item.code : item));
  }

  toUrl(filterData: MultiSelectValue): string | null {
    if (!Array.isArray(filterData) || filterData.length === 0) return null;
    return filterData
      .map(item => (typeof item === 'object' ? item.code : item))
      .join(',');
  }

  fromUrl(paramValue: string, options: OptionsMap): MultiSelectValue {
    const codes = paramValue.includes(',') ? paramValue.split(',') : [paramValue];
    return codes.map(code => ({ code, label: options[code] ?? code }));
  }
}


